import type { FilterOptionOption } from "react-select";

import type { SelectOption } from "components/v2/Select/types";

export function filterPackingListSelectOption(
  option: FilterOptionOption<SelectOption>,
  inputValue: string,
): boolean {
  if (!inputValue) return true;

  const search = inputValue.toLowerCase().trim();
  const { label, supportingText } = option.data;

  return (
    label.toLowerCase().includes(search) ||
    Boolean(supportingText?.toLowerCase().includes(search))
  );
}
